module.exports = __webpack_public_path__ + "static/media/noBack.a1965214.svg";